import React, { useEffect, useState } from 'react'
import Sidebar from '../../../components/sidebar/sidebar'
import Navbar from "../../../components/navbar"
import { AddNewButton } from '../../../components/buttoncomponents'
import Informations_form from '../common/informations_form'
import Listing from '../common/listing'
import { Card } from 'react-bootstrap'
import {AddCategory} from '../../../helpers/API/ProductApi'
import axios from 'axios'
import * as CONFIG from "../../../helpers/config"
import { useMsal } from "@azure/msal-react";

export default function Index() {
    const { instance } = useMsal();
    const [isFirst, setIsFirst] = useState(true);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [produtCat, setProdcutCat] = useState([]);
    const [length, setLength] = useState(0)
    const [isEdit, setIsEdit] = useState(false)
    const [selectedData, setSelectedData] = useState([]);
    const [error, setError] = useState(false);
    const [errorData, setErrorData] = useState('');
    const addCategory = ()=>{
        setIsAddCategory(!isAddCategory);
    }
    
    useEffect(()=>{
       if(isFirst){
            getlist()
       }
       
       setIsFirst(false)
    })

    const getlist = ()=>{
        const json_list = {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID
        }
        axios.post(CONFIG.TMS_SERVER_URL+CONFIG.GET_PRODUCT_CATEGORY, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
            console.log(res.data.result)
            setProdcutCat(res.data.result);
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
    }

    const saveCategory = (data)=>{
        console.log(data)
        const json_list = isEdit?{
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID,
            "Modified_User" : CONFIG.LoginID,
            "productCategoryID": data.id,
            "productCategoryName": data.data
        }
        :
        {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "productCategoryName" : data.data,
            "created_User" : CONFIG.LoginID
        }
       if(!isEdit){
            axios.post(CONFIG.TMS_SERVER_URL+CONFIG.ADD_PRODUCT_CATEGORY, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {
                if(res.data.responseCode == '303002'){
                    setError(true)
                    setErrorData('Product category already exists');
                }
                else if(res.data.responseCode == '303001'){
                    setError(true)
                    setErrorData('Product category invalid. Please try again!');
                }
                else{
                    setError(false)
                }
                setIsEdit(false)
                getlist()
            }).catch((error)=>{
                if(error.response.status == 401){
                    localStorage.clear();
                    instance.logoutRedirect({
                      postLogoutRedirectUri: "/",
                    });
                }
            })  
       }
       else{
            axios.post(CONFIG.TMS_SERVER_URL+CONFIG.EDIT_PRODUCT_CATEGORY, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {
                if(res.data.responseCode == '303002'){
                    setError(true)
                    setErrorData('Product category already exists');
                }
                else if(res.data.responseCode == '303001'){
                    setError(true)
                    setErrorData('Product category invalid. Please try again!');
                }
                else{
                    setError(false)
                }
                console.log(res)
                setIsEdit(false)
                getlist()
            }).catch((error)=>{
                if(error.response.status == 401){
                    localStorage.clear();
                    instance.logoutRedirect({
                      postLogoutRedirectUri: "/",
                    });
                }
            })  
       }
    }

    const edit = (e)=>{
        const id = e.target.id;
        let data = produtCat.filter(x=> x.productCategoryID == id);
        setSelectedData(data);
        setIsEdit(true)
        addCategory();
    }
    const deletedata = (e)=>{
        const id = parseInt(e.target.id);
        const json_list = {
            "instanceID" : CONFIG.PMSInstanceID,
            "accountSubscriptionID" : CONFIG.AccountSubscriptionID,
            "created_User" : CONFIG.LoginID,
            "id" : id
        }
        axios.post(CONFIG.TMS_SERVER_URL+CONFIG.DELETE_PRODUCT_CATEGORY, json_list, { headers: {"Authorization": `Bearer ${CONFIG.AuthToken}`,  "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
        .then((res) => {
            getlist()
        }).catch((error)=>{
            if(error.response.status == 401){
                localStorage.clear();
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                });
            }
        })  
    }
    return (
        <div className='main-wrapper inner-wrapper d-flex'>
                
                <Sidebar id='4.2' isOpenid={4}/>
                <div className='width-100'>
                    <Navbar/>
                    <div className='d-flex inner-page-header justify-content-between'>
                        <div className='d-flex'>
                            <img src='assets/images/pageicons/productsicon.svg' className='inner-page-titleicon img-fluid'/><span className='font-16 font-weight-600 color-707895 d-flex align-items-center pl-10'>PRODUCT CATEGORY-01</span>
                        </div>
                    </div>
                    
                        <div className='mx-4 br-8 py-3'>
                                <Card className='p-2-rem col-md-7'>
                                    <div className='d-flex justify-content-end'>
                                        <AddNewButton value='Add New Category' class='bg-white' clickEvent={addCategory}/>
                                    </div>
                                    {isAddCategory && 
                                        <Informations_form 
                                            isOpen={isAddCategory} 
                                            title={'ADD NEW PRODCUT CATEGORY'} 
                                            buttontext ={isEdit?'Edit Category':'Add Category'}
                                            inputLabel = 'Product Category*'
                                            onSave={saveCategory}
                                            toggle={addCategory}
                                            id={isEdit?selectedData[0].productCategoryID:''}
                                            name={isEdit?selectedData[0].productCategoryName:''}
                                            isEdit={isEdit}
                                        />
                                    }
                                    {error &&
                                        <div className='input_error'>{errorData}</div>
                                    }
                                    <table className="table pcustom table-text mt-1-rem">
                                        <thead>
                                            <tr className='bg-F8F9FA font-weight-500 color-707895'>
                                                <th>Product Category</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {produtCat.map((cat,k)=>(
                                                <Listing key={k} id={cat.productCategoryID} name={cat.productCategoryName} length={length} edit={edit} delete={deletedata}/>
                                            ))}
                                        </tbody>
                                    </table>
                                </Card>
                        </div>
                    </div>
                
                

        </div>
    )
}
